// kapigen version 0.1.33
// eslint-disable
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { google } from "../google";
import { createClient, createRawStringClient, jsonStringToDuration } from "../../requestClientInternal";
import { PrivatedModerationStatusWireFormat3 as KaggleSdkAbusePrivatedModerationStatusWireFormat3 } from "../abuse";
import { CategoryWireFormat3 as KaggleSdkCommonCategoryWireFormat3, PageMessageWireFormat3 as KaggleSdkCommonPageMessageWireFormat3, VoteButtonWireFormat3 as KaggleSdkCommonVoteButtonWireFormat3 } from "../common";
import { EnvironmentRenderTypeWireFormat3 as KaggleSdkCompetitionsEnvironmentRenderTypeWireFormat3, EpisodeTypeWireFormat3 as KaggleSdkCompetitionsEpisodeTypeWireFormat3 } from "../competitions";
import { KernelOutputDatasetReferenceWireFormat3 as KaggleSdkDatasetsKernelOutputDatasetReferenceWireFormat3, KernelTaskSubmissionInfoWireFormat3 as KaggleSdkDatasetsKernelTaskSubmissionInfoWireFormat3 } from "../datasets";
import { DatabundleOwnerInfoWireFormat3 as KaggleSdkDatasetsDatabundlesDatabundleOwnerInfoWireFormat3, DataSourceWireFormat3 as KaggleSdkDatasetsDatabundlesDataSourceWireFormat3, DirectoryWireFormat3 as KaggleSdkDatasetsDatabundlesDirectoryWireFormat3, FileWireFormat3 as KaggleSdkDatasetsDatabundlesFileWireFormat3 } from "../datasets/databundles";
import { LearnSeriesNavigationDataWireFormat3 as KaggleSdkEducationLearnSeriesNavigationDataWireFormat3 } from "../education";
import { ModelFrameworkWireFormat3 as KaggleSdkModelsModelFrameworkWireFormat3 } from "../models";
import { IndexSnippetResponseWireFormat3 as KaggleSdkSearchIndexSnippetResponseWireFormat3 } from "../search";
import { TagListWireFormat3 as KaggleSdkTagsTagListWireFormat3 } from "../tags";
import { CollaboratorListWireFormat3 as KaggleSdkUsersCollaboratorListWireFormat3, MedalWireFormat3 as KaggleSdkUsersMedalWireFormat3, UserWireFormat3 as KaggleSdkUsersUserWireFormat3 } from "../users";
var defaultAcceleratorQuotaStatistics = {
    hasEverRun: false
};
export var AcceleratorQuotaStatisticsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultAcceleratorQuotaStatistics, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.minimumTimeAllowed) {
            message.minimumTimeAllowed = jsonStringToDuration(wireFormat.minimumTimeAllowed);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.timeReserved) {
            message.timeReserved = jsonStringToDuration(wireFormat.timeReserved);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.timeUsed) {
            message.timeUsed = jsonStringToDuration(wireFormat.timeUsed);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalTimeAllowed) {
            message.totalTimeAllowed = jsonStringToDuration(wireFormat.totalTimeAllowed);
        }
        return message;
    }
};
export var AcceptKernelCompetitionRulesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var AddKernelCategoryRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var AgentEntryWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var CancelKernelSessionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ClearPinnedKernelSessionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var CommitAndRunRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.dataSources) {
            wireFormat.dataSources = message.dataSources.map(function(i) {
                return DataSourceReferenceWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.editorType) {
            wireFormat.editorType = EditorTypeWireFormat3.toJson(message.editorType);
        }
        if (message === null || message === void 0 ? void 0 : message.compute) {
            wireFormat.compute = ComputeStateWireFormat3.toJson(message.compute);
        }
        if (message === null || message === void 0 ? void 0 : message.versionType) {
            wireFormat.versionType = KernelVersionTypeWireFormat3.toJson(message.versionType);
        }
        if (message === null || message === void 0 ? void 0 : message.submissionRequestedDetails) {
            wireFormat.submissionRequestedDetails = SubmissionRequestedDetailsWireFormat3.toJson(message.submissionRequestedDetails);
        }
        if (message === null || message === void 0 ? void 0 : message.githubSaveRequest) {
            wireFormat.githubSaveRequest = GitHubSaveRequestWireFormat3.toJson(message.githubSaveRequest);
        }
        if (message === null || message === void 0 ? void 0 : message.creationSource) {
            wireFormat.creationSource = CreationSourceWireFormat3.toJson(message.creationSource);
        }
        return wireFormat;
    }
};
var defaultCommitAndRunResponse = {
    kernelId: 0,
    kernelVersionId: 0,
    kernelRunId: 0
};
export var CommitAndRunResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCommitAndRunResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.diff) {
            message.diff = KernelDiffWireFormat3.fromJson(wireFormat.diff);
        }
        if (wireFormat) {
            message.status = KernelWorkerStatusWireFormat3.fromJson(wireFormat.status);
        }
        return message;
    }
};
var defaultCompetitionKernelsLists = {};
export var CompetitionKernelsListsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionKernelsLists, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.pinnedKernels) {
            message.pinnedKernels = KernelListWireFormat3.fromJson(wireFormat.pinnedKernels);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.unpinnedKernels) {
            message.unpinnedKernels = KernelListWireFormat3.fromJson(wireFormat.unpinnedKernels);
        }
        return message;
    }
};
export var CompleteQuickSessionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCompleteQuickSessionResponse = {};
export var CompleteQuickSessionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompleteQuickSessionResponse, wireFormat);
        return message;
    }
};
export var ComputeConstraintStateWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.maxStorageBytes) {
            wireFormat.maxStorageBytes = message.maxStorageBytes.toString();
        }
        if (message === null || message === void 0 ? void 0 : message.maxMemoryBytes) {
            wireFormat.maxMemoryBytes = message.maxMemoryBytes.toString();
        }
        return wireFormat;
    }
};
export var ComputeInternetStateWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ComputeKernelDiffRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultComputeKernelDiffResponse = {};
export var ComputeKernelDiffResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultComputeKernelDiffResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.diff) {
            message.diff = KernelDiffWireFormat3.fromJson(wireFormat.diff);
        }
        return message;
    }
};
export var ComputeStateWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.accelerator) {
            wireFormat.accelerator = AcceleratorTypeWireFormat3.toJson(message.accelerator);
        }
        if (message === null || message === void 0 ? void 0 : message.internet) {
            wireFormat.internet = ComputeInternetStateWireFormat3.toJson(message.internet);
        }
        if (message === null || message === void 0 ? void 0 : message.constraints) {
            wireFormat.constraints = ComputeConstraintStateWireFormat3.toJson(message.constraints);
        }
        return wireFormat;
    }
};
export var CreateKernelParametersWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.compute) {
            wireFormat.compute = ComputeStateWireFormat3.toJson(message.compute);
        }
        if (message === null || message === void 0 ? void 0 : message.dataSources) {
            wireFormat.dataSources = message.dataSources.map(function(i) {
                return DataSourceReferenceWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
export var CreateKernelPinRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCreateKernelPinResponse = {
    kernelPinned: false
};
export var CreateKernelPinResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateKernelPinResponse, wireFormat);
        return message;
    }
};
export var CreateKernelSessionRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.versionType) {
            wireFormat.versionType = KernelVersionTypeWireFormat3.toJson(message.versionType);
        }
        if (message === null || message === void 0 ? void 0 : message.diff) {
            wireFormat.diff = KernelDiffWireFormat3.toJson(message.diff);
        }
        if (message === null || message === void 0 ? void 0 : message.forkParentDiff) {
            wireFormat.forkParentDiff = KernelDiffWireFormat3.toJson(message.forkParentDiff);
        }
        if (message === null || message === void 0 ? void 0 : message.submissionRequestedDetails) {
            wireFormat.submissionRequestedDetails = SubmissionRequestedDetailsWireFormat3.toJson(message.submissionRequestedDetails);
        }
        if (message === null || message === void 0 ? void 0 : message.parameters) {
            wireFormat.parameters = CreateKernelParametersWireFormat3.toJson(message.parameters);
        }
        if (message === null || message === void 0 ? void 0 : message.githubSaveRequest) {
            wireFormat.githubSaveRequest = GitHubSaveRequestWireFormat3.toJson(message.githubSaveRequest);
        }
        if (message === null || message === void 0 ? void 0 : message.environmentVariables) {
            wireFormat.environmentVariables = message.environmentVariables.map(function(i) {
                return EnvironmentVariableWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.creationSource) {
            wireFormat.creationSource = CreationSourceWireFormat3.toJson(message.creationSource);
        }
        return wireFormat;
    }
};
var defaultCreateKernelSessionResponse = {
    id: 0,
    useNewKernelsBackend: false,
    showParentForkSecretWarning: false
};
export var CreateKernelSessionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateKernelSessionResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.resources) {
            message.resources = KernelSessionResourcesWireFormat3.fromJson(wireFormat.resources);
        }
        return message;
    }
};
export var CreateKernelUpvoteRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCreateKernelUpvoteResponse = {
    voteId: 0,
    isSelfVote: false
};
export var CreateKernelUpvoteResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateKernelUpvoteResponse, wireFormat);
        return message;
    }
};
export var CreateSnippetRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.data) {
            wireFormat.data = SnippetDataWireFormat3.toJson(message.data);
        }
        return wireFormat;
    }
};
var defaultCreateSnippetResponse = {
    id: 0
};
export var CreateSnippetResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateSnippetResponse, wireFormat);
        return message;
    }
};
export var CreationSourceWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.type) {
            wireFormat.type = CreationSourceTypeWireFormat3.toJson(message.type);
        }
        return wireFormat;
    }
};
var defaultDailySubmissionInfo = {
    submissionCount: 0
};
export var DailySubmissionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDailySubmissionInfo, wireFormat);
        return message;
    }
};
var defaultDataSource = {
    isPrivate: false
};
export var DataSourceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDataSource, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.reference) {
            message.reference = DataSourceReferenceWireFormat3.fromJson(wireFormat.reference);
        }
        return message;
    }
};
var defaultDataSourceReference = {
    sourceId: 0
};
export var DataSourceReferenceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDataSourceReference, wireFormat);
        if (wireFormat) {
            message.sourceType = DataSourceTypeWireFormat3.fromJson(wireFormat.sourceType);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.sourceType) {
            wireFormat.sourceType = DataSourceTypeWireFormat3.toJson(message.sourceType);
        }
        return wireFormat;
    }
};
var defaultDataSourceVersion = {};
export var DataSourceVersionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDataSourceVersion, wireFormat);
        return message;
    }
};
var defaultDefaultSessionSettings = {};
export var DefaultSessionSettingsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDefaultSessionSettings, wireFormat);
        if (wireFormat) {
            message.batchSessionDefaultAccelerator = AcceleratorTypeWireFormat3.fromJson(wireFormat.batchSessionDefaultAccelerator);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.batchSessionDefaultAccelerator) {
            wireFormat.batchSessionDefaultAccelerator = AcceleratorTypeWireFormat3.toJson(message.batchSessionDefaultAccelerator);
        }
        return wireFormat;
    }
};
export var DeleteKernelPinRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDeleteKernelPinResponse = {
    kernelPinned: false
};
export var DeleteKernelPinResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDeleteKernelPinResponse, wireFormat);
        return message;
    }
};
export var DeleteKernelRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteKernelUpvoteRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteScheduledKernelSessionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDeleteScheduledKernelSessionResponse = {};
export var DeleteScheduledKernelSessionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDeleteScheduledKernelSessionResponse, wireFormat);
        return message;
    }
};
export var DeleteSnippetRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDockerImageVersionDetails = {};
export var DockerImageVersionDetailsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDockerImageVersionDetails, wireFormat);
        if (wireFormat) {
            message.type = DockerImageVersionTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat) {
            message.disabledReason = DockerImageVersionDisabledReasonWireFormat3.fromJson(wireFormat.disabledReason);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCreated) {
            message.dateCreated = new Date(wireFormat.dateCreated);
        }
        return message;
    }
};
var defaultDockerImageVersionDetailsList = {
    images: []
};
export var DockerImageVersionDetailsListWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDockerImageVersionDetailsList, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.images) {
            message.images = wireFormat.images.map(function(i) {
                return DockerImageVersionDetailsWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.selectedVersionType = DockerImageVersionTypeWireFormat3.fromJson(wireFormat.selectedVersionType);
        }
        return message;
    }
};
export var EnvironmentVariableWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ExportKernelRunForCaipRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultExportKernelRunForCaipResponse = {
    warnings: []
};
export var ExportKernelRunForCaipResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultExportKernelRunForCaipResponse, wireFormat);
        return message;
    }
};
export var ExternalSourceDataWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var FetchExternalKernelContentRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var FetchGitHubContentRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultFetchGitHubContentResponse = {
    content: "",
    isPublic: false
};
export var FetchGitHubContentResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFetchGitHubContentResponse, wireFormat);
        return message;
    }
};
var defaultForkParentInfo = {
    isDeleted: false,
    isVisible: false,
    kernelId: 0
};
export var ForkParentInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultForkParentInfo, wireFormat);
        return message;
    }
};
export var GetAcceleratorQuotaStatisticsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetAcceleratorQuotaStatisticsResponse = {
    kernelsMaxSizeInMb: 0
};
export var GetAcceleratorQuotaStatisticsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetAcceleratorQuotaStatisticsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.quotaRefreshTime) {
            message.quotaRefreshTime = new Date(wireFormat.quotaRefreshTime);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tpuQuota) {
            message.tpuQuota = AcceleratorQuotaStatisticsWireFormat3.fromJson(wireFormat.tpuQuota);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.gpuQuota) {
            message.gpuQuota = AcceleratorQuotaStatisticsWireFormat3.fromJson(wireFormat.gpuQuota);
        }
        return message;
    }
};
export var GetCompetitionsPaneInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetCompetitionsPaneInfoResponse = {};
export var GetCompetitionsPaneInfoResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetCompetitionsPaneInfoResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bestKernelSessionScore) {
            message.bestKernelSessionScore = KernelSessionScoreWireFormat3.fromJson(wireFormat.bestKernelSessionScore);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.latestKernelSessionScore) {
            message.latestKernelSessionScore = KernelSessionScoreWireFormat3.fromJson(wireFormat.latestKernelSessionScore);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dailySubmissionInfo) {
            message.dailySubmissionInfo = DailySubmissionInfoWireFormat3.fromJson(wireFormat.dailySubmissionInfo);
        }
        return message;
    }
};
export var GetDefaultSessionSettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetDeletedKernelRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetDeletedKernelResponse = {
    commentCount: 0,
    userCanDownvoteComments: false
};
export var GetDeletedKernelResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetDeletedKernelResponse, wireFormat);
        return message;
    }
};
export var GetFirebaseAuthTokenRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetFirebaseAuthTokenResponse = {
    authToken: ""
};
export var GetFirebaseAuthTokenResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetFirebaseAuthTokenResponse, wireFormat);
        return message;
    }
};
export var GetFirebaseConfigRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetFirebaseConfigResponse = {
    apiKey: "",
    authDomain: "",
    databaseUrl: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    proxyDomain: ""
};
export var GetFirebaseConfigResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetFirebaseConfigResponse, wireFormat);
        return message;
    }
};
export var GetKernelCategoryIdsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetKernelCollaboratorListRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetKernelCollaboratorListResponse = {};
export var GetKernelCollaboratorListResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetKernelCollaboratorListResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaboratorList) {
            message.collaboratorList = KaggleSdkUsersCollaboratorListWireFormat3.fromJson(wireFormat.collaboratorList);
        }
        return message;
    }
};
export var GetKernelGitHubSettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetKernelGitHubSettingsResponse = {
    githubLogin: "",
    repositories: [],
    branches: []
};
export var GetKernelGitHubSettingsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetKernelGitHubSettingsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.repositories) {
            message.repositories = wireFormat.repositories.map(function(i) {
                return GithubRepositoryInfoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.branches) {
            message.branches = wireFormat.branches.map(function(i) {
                return GithubBranchInfoWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastSettings) {
            message.lastSettings = GitHubSaveRequestWireFormat3.fromJson(wireFormat.lastSettings);
        }
        return message;
    }
};
export var GetKernelIdByUrlRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetKernelIdByUrlResponse = {
    kernelId: 0
};
export var GetKernelIdByUrlResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetKernelIdByUrlResponse, wireFormat);
        return message;
    }
};
export var GetKernelLandingPageRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetKernelLandingPageResponse = {
    shelves: [],
    totalPublicKernels: 0
};
export var GetKernelLandingPageResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetKernelLandingPageResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.shelves) {
            message.shelves = wireFormat.shelves.map(function(i) {
                return KernelShelfWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetKernelListDetailsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.unauthorizedAccessBehavior) {
            wireFormat.unauthorizedAccessBehavior = AccessBehaviorWireFormat3.toJson(message.unauthorizedAccessBehavior);
        }
        if (message === null || message === void 0 ? void 0 : message.deletedAccessBehavior) {
            wireFormat.deletedAccessBehavior = AccessBehaviorWireFormat3.toJson(message.deletedAccessBehavior);
        }
        if (message === null || message === void 0 ? void 0 : message.readMask) {
            var _paths;
            wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
export var GetKernelRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.readMask) {
            var _paths;
            wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
export var GetKernelRunSourceRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetKernelSessionDataSourcesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetKernelSessionDataSourcesResponse = {
    dataSources: []
};
export var GetKernelSessionDataSourcesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetKernelSessionDataSourcesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
            message.dataSources = wireFormat.dataSources.map(function(i) {
                return KaggleSdkDatasetsDatabundlesDataSourceWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetKernelSessionLogRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetKernelSessionModelSourcesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetKernelSessionModelSourcesResponse = {
    modelSources: []
};
export var GetKernelSessionModelSourcesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetKernelSessionModelSourcesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.modelSources) {
            message.modelSources = wireFormat.modelSources.map(function(i) {
                return ModelSourceWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetKernelStatusRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.existingStatus) {
            wireFormat.existingStatus = KernelWorkerStatusWireFormat3.toJson(message.existingStatus);
        }
        return wireFormat;
    }
};
var defaultGetKernelStatusResponse = {};
export var GetKernelStatusResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetKernelStatusResponse, wireFormat);
        if (wireFormat) {
            message.status = KernelWorkerStatusWireFormat3.fromJson(wireFormat.status);
        }
        return message;
    }
};
export var GetKernelVersionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetKernelVersionResponse = {};
export var GetKernelVersionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetKernelVersionResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelVersionAndRun) {
            message.kernelVersionAndRun = KernelVersionAndRunWireFormat3.fromJson(wireFormat.kernelVersionAndRun);
        }
        return message;
    }
};
var defaultGetKernelViewModelResponse = {
    outputFiles: [],
    pageMessages: [],
    dataSources: [],
    renderableDataSources: [],
    versions: [],
    menuLinks: [],
    rightMenuLinks: [],
    canWrite: false,
    canAdminister: false,
    currentUserHasForked: false,
    forkParentIsRedacted: false,
    forkDiffLinesChanged: 0,
    forkDiffLinesDeleted: 0,
    forkDiffLinesInserted: 0,
    simplifiedViewer: false,
    disableComments: false,
    showSharingControls: false,
    showUnchangedCopyWarning: false,
    isReportedBannerDismissed: false,
    showAdminAllowlist: false,
    isReportedModalDismissed: false
};
export var GetKernelViewModelResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetKernelViewModelResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernel) {
            message.kernel = KernelWireFormat3.fromJson(wireFormat.kernel);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelBlob) {
            message.kernelBlob = KernelBlobWireFormat3.fromJson(wireFormat.kernelBlob);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelRun) {
            message.kernelRun = KernelRunWireFormat3.fromJson(wireFormat.kernelRun);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.author) {
            message.author = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.author);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaborators) {
            message.collaborators = KaggleSdkUsersCollaboratorListWireFormat3.fromJson(wireFormat.collaborators);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.outputFiles) {
            message.outputFiles = wireFormat.outputFiles.map(function(i) {
                return KernelSessionOutputFileWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.ouputFilesOwnerInfo) {
            message.ouputFilesOwnerInfo = KaggleSdkDatasetsDatabundlesDatabundleOwnerInfoWireFormat3.fromJson(wireFormat.ouputFilesOwnerInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.pageMessages) {
            message.pageMessages = wireFormat.pageMessages.map(function(i) {
                return KaggleSdkCommonPageMessageWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
            message.dataSources = wireFormat.dataSources.map(function(i) {
                return DataSourceReferenceWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.renderableDataSources) {
            message.renderableDataSources = wireFormat.renderableDataSources.map(function(i) {
                return DataSourceWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.versions) {
            message.versions = wireFormat.versions.map(function(i) {
                return KernelVersionHistoryWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submission) {
            message.submission = KernelSubmissionWireFormat3.fromJson(wireFormat.submission);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bestSubmissionScore) {
            message.bestSubmissionScore = KernelSessionScoreWireFormat3.fromJson(wireFormat.bestSubmissionScore);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.latestSubmissionScore) {
            message.latestSubmissionScore = KernelSessionScoreWireFormat3.fromJson(wireFormat.latestSubmissionScore);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.menuLinks) {
            message.menuLinks = wireFormat.menuLinks.map(function(i) {
                return LinkModelWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rightMenuLinks) {
            message.rightMenuLinks = wireFormat.rightMenuLinks.map(function(i) {
                return LinkModelWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.callToAction) {
            message.callToAction = LinkModelWireFormat3.fromJson(wireFormat.callToAction);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.voteButton) {
            message.voteButton = KaggleSdkCommonVoteButtonWireFormat3.fromJson(wireFormat.voteButton);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelOutputDataset) {
            message.kernelOutputDataset = KaggleSdkDatasetsKernelOutputDatasetReferenceWireFormat3.fromJson(wireFormat.kernelOutputDataset);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.taskSubmissionInfo) {
            message.taskSubmissionInfo = KaggleSdkDatasetsKernelTaskSubmissionInfoWireFormat3.fromJson(wireFormat.taskSubmissionInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.learnSeriesNavigationData) {
            message.learnSeriesNavigationData = KaggleSdkEducationLearnSeriesNavigationDataWireFormat3.fromJson(wireFormat.learnSeriesNavigationData);
        }
        if (wireFormat) {
            message.moderationStatus = KaggleSdkAbusePrivatedModerationStatusWireFormat3.fromJson(wireFormat.moderationStatus);
        }
        return message;
    }
};
export var GetOrCreateKernelSessionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetOrCreateKernelSessionResponse = {
    sessionTimeoutSeconds: 0,
    hasMoreRecentCollaboratorVersion: false
};
export var GetOrCreateKernelSessionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetOrCreateKernelSessionResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.draft) {
            message.draft = KernelDraftWireFormat3.fromJson(wireFormat.draft);
        }
        if (wireFormat) {
            message.unusedAcceleratorRemoved = AcceleratorTypeWireFormat3.fromJson(wireFormat.unusedAcceleratorRemoved);
        }
        if (wireFormat) {
            message.sessionStatus = KernelWorkerStatusWireFormat3.fromJson(wireFormat.sessionStatus);
        }
        return message;
    }
};
export var GetScheduledKernelSessionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetScheduledKernelSessionResponse = {};
export var GetScheduledKernelSessionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetScheduledKernelSessionResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.session) {
            message.session = ScheduledKernelSessionWireFormat3.fromJson(wireFormat.session);
        }
        return message;
    }
};
export var GetSourceIndexDataRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetSourceIndexDataResponse = {
    references: []
};
export var GetSourceIndexDataResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetSourceIndexDataResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.definition) {
            message.definition = SourceIndexReferenceWireFormat3.fromJson(wireFormat.definition);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.references) {
            message.references = wireFormat.references.map(function(i) {
                return SourceIndexReferenceWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetUserKernelAchievementsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetUserKernelAchievementsResponse = {
    totalUpvotes: 0,
    totalKernels: 0,
    totalForks: 0,
    weeklyForks: 0
};
export var GetUserKernelAchievementsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetUserKernelAchievementsResponse, wireFormat);
        return message;
    }
};
var defaultGithubBranchInfo = {
    name: ""
};
export var GithubBranchInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGithubBranchInfo, wireFormat);
        return message;
    }
};
var defaultGithubFileInfo = {
    owner: "",
    repo: "",
    path: "",
    ref: "",
    rawUrl: ""
};
export var GithubFileInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGithubFileInfo, wireFormat);
        return message;
    }
};
var defaultGithubRepositoryInfo = {
    owner: "",
    name: "",
    defaultBranch: ""
};
export var GithubRepositoryInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGithubRepositoryInfo, wireFormat);
        return message;
    }
};
var defaultGitHubSaveRequest = {
    repositoryOwner: "",
    repositoryName: "",
    branch: "",
    fileName: "",
    commitMessage: "",
    includeKaggleBadge: false
};
export var GitHubSaveRequestWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGitHubSaveRequest, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
export var HasAcceptedKernelCompetitionRulesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultHasAcceptedKernelCompetitionRulesResponse = {
    competitionsRequiringAcceptance: []
};
export var HasAcceptedKernelCompetitionRulesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHasAcceptedKernelCompetitionRulesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitionsRequiringAcceptance) {
            message.competitionsRequiringAcceptance = wireFormat.competitionsRequiringAcceptance.map(function(i) {
                return KernelCompetitionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var IndexAllSnippetsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultIndexAllSnippetsResponse = {
    numberOfSnippetsToIndex: 0
};
export var IndexAllSnippetsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultIndexAllSnippetsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.searchIndexResult) {
            message.searchIndexResult = KaggleSdkSearchIndexSnippetResponseWireFormat3.fromJson(wireFormat.searchIndexResult);
        }
        return message;
    }
};
var defaultKernel = {
    id: 0,
    tags: [],
    commentCount: 0,
    upvoteCount: 0,
    viewCount: 0,
    forkCount: 0,
    isPrivate: false,
    isLanguageTemplate: false,
    disableComments: false,
    hasLinkedSubmission: false,
    currentUserHasBookmarked: false,
    canToggleVisibility: false
};
export var KernelWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernel, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.forkParent) {
            message.forkParent = KernelForkInfoWireFormat3.fromJson(wireFormat.forkParent);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tags) {
            message.tags = wireFormat.tags.map(function(i) {
                return TagWireFormat3.fromJson(i);
            });
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bestPublicScore) != undefined) {
            message.bestPublicScore = Number(wireFormat.bestPublicScore);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.author) {
            message.author = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.author);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.updatedTime) {
            message.updatedTime = new Date(wireFormat.updatedTime);
        }
        if (wireFormat) {
            message.dockerImagePinningType = DockerImagePinningTypeWireFormat3.fromJson(wireFormat.dockerImagePinningType);
        }
        if (wireFormat) {
            message.medal = KaggleSdkUsersMedalWireFormat3.fromJson(wireFormat.medal);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateOutputToDatasetEnabled) {
            message.dateOutputToDatasetEnabled = new Date(wireFormat.dateOutputToDatasetEnabled);
        }
        if (wireFormat) {
            message.persistence = PersistenceModeWireFormat3.fromJson(wireFormat.persistence);
        }
        return message;
    }
};
var defaultKernelBlob = {
    id: 0
};
export var KernelBlobWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelBlob, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.settings) {
            message.settings = KernelBlobSettingsWireFormat3.fromJson(wireFormat.settings);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCreated) {
            message.dateCreated = new Date(wireFormat.dateCreated);
        }
        return message;
    }
};
var defaultKernelBlobSettings = {
    dataSources: [],
    isInternetEnabled: false,
    isGpuEnabled: false
};
export var KernelBlobSettingsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelBlobSettings, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
            message.dataSources = wireFormat.dataSources.map(function(i) {
                return DataSourceReferenceWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.sourceType = EditorTypeWireFormat3.fromJson(wireFormat.sourceType);
        }
        if (wireFormat) {
            message.language = LanguageWireFormat3.fromJson(wireFormat.language);
        }
        if (wireFormat) {
            message.accelerator = AcceleratorTypeWireFormat3.fromJson(wireFormat.accelerator);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.dataSources) {
            wireFormat.dataSources = message.dataSources.map(function(i) {
                return DataSourceReferenceWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.sourceType) {
            wireFormat.sourceType = EditorTypeWireFormat3.toJson(message.sourceType);
        }
        if (message === null || message === void 0 ? void 0 : message.language) {
            wireFormat.language = LanguageWireFormat3.toJson(message.language);
        }
        if (message === null || message === void 0 ? void 0 : message.accelerator) {
            wireFormat.accelerator = AcceleratorTypeWireFormat3.toJson(message.accelerator);
        }
        return wireFormat;
    }
};
var defaultKernelCategoryIdList = {
    categoryIds: []
};
export var KernelCategoryIdListWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelCategoryIdList, wireFormat);
        return message;
    }
};
var defaultKernelCompetition = {
    competitionId: 0,
    title: "",
    rulesUrl: ""
};
export var KernelCompetitionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelCompetition, wireFormat);
        return message;
    }
};
var defaultKernelDiff = {
    linesInserted: 0,
    linesDeleted: 0,
    linesChanged: 0,
    linesUnchanged: 0,
    newTotalLines: 0
};
export var KernelDiffWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelDiff, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
var defaultKernelDraft = {
    sequence: 0,
    kernelVersionId: 0,
    hasMoreRecentCollaboratorVersion: false
};
export var KernelDraftWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelDraft, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.blob) {
            message.blob = KernelBlobWireFormat3.fromJson(wireFormat.blob);
        }
        return message;
    }
};
var defaultKernelForkInfo = {
    kernelId: 0,
    runId: 0,
    isRedacted: false,
    isPrivate: false,
    isFork: false
};
export var KernelForkInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelForkInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.author) {
            message.author = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.author);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.diff) {
            message.diff = KernelDiffWireFormat3.fromJson(wireFormat.diff);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCreated) {
            message.dateCreated = new Date(wireFormat.dateCreated);
        }
        if (wireFormat) {
            message.workerStatus = KernelWorkerStatusWireFormat3.fromJson(wireFormat.workerStatus);
        }
        if (wireFormat) {
            message.versionType = KernelVersionTypeWireFormat3.fromJson(wireFormat.versionType);
        }
        return message;
    }
};
var defaultKernelList = {
    kernels: []
};
export var KernelListWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelList, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernels) {
            message.kernels = wireFormat.kernels.map(function(i) {
                return KernelListItemWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultKernelListItem = {
    currentUserHasVotedForThisScript: false,
    dataSources: [],
    forkDiffLinesChanged: 0,
    forkDiffLinesDeleted: 0,
    forkDiffLinesInserted: 0,
    hasCollaborators: false,
    id: 0,
    isFork: false,
    isPrivate: false,
    isNotebook: false,
    isGpuEnabled: false,
    categories: [],
    totalComments: 0,
    totalForks: 0,
    totalScripts: 0,
    totalViews: 0,
    totalVotes: 0,
    totalLines: 0,
    currentUserHasBookmarked: false,
    isRunning: false,
    isDeleted: false,
    isMyUncommittedDraft: false,
    outputFiles: [],
    canCurrentUserDeleteKernel: false,
    canCurrentUserEditKernel: false,
    hasLinkedSubmission: false,
    disableComments: false,
    scriptUrl: "",
    scriptCommentsUrl: "",
    scriptInputUrl: "",
    scriptEditUrl: "",
    hasDataOutputFiles: false
};
export var KernelListItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelListItem, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.author) {
            message.author = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.author);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
            message.dataSources = wireFormat.dataSources.map(function(i) {
                return DataSourceWireFormat3.fromJson(i);
            });
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bestPublicScore) != undefined) {
            message.bestPublicScore = Number(wireFormat.bestPublicScore);
        }
        if (wireFormat) {
            message.medal = KaggleSdkUsersMedalWireFormat3.fromJson(wireFormat.medal);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.categories) {
            message.categories = wireFormat.categories.map(function(i) {
                return KaggleSdkCommonCategoryWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.scriptVersionDateCreated) {
            message.scriptVersionDateCreated = new Date(wireFormat.scriptVersionDateCreated);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateEvaluated) {
            message.dateEvaluated = new Date(wireFormat.dateEvaluated);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.outputFiles) {
            message.outputFiles = wireFormat.outputFiles.map(function(i) {
                return KernelSessionOutputFileWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.taskSubmissionInfo) {
            message.taskSubmissionInfo = KaggleSdkDatasetsKernelTaskSubmissionInfoWireFormat3.fromJson(wireFormat.taskSubmissionInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.forkParentInfo) {
            message.forkParentInfo = ForkParentInfoWireFormat3.fromJson(wireFormat.forkParentInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateOutputToDatasetEnabled) {
            message.dateOutputToDatasetEnabled = new Date(wireFormat.dateOutputToDatasetEnabled);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastRunTime) {
            message.lastRunTime = new Date(wireFormat.lastRunTime);
        }
        return message;
    }
};
var defaultKernelPinListItem = {
    kernelId: 0
};
export var KernelPinListItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelPinListItem, wireFormat);
        return message;
    }
};
var defaultKernelRun = {
    id: 0,
    kernelId: 0,
    scriptLanguageId: 0,
    usedCustomDockerImage: false,
    dataSources: [],
    isGpuEnabled: false,
    isTpuEnabled: false,
    isInternetEnabled: false,
    isKernelScheduled: false
};
export var KernelRunWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelRun, wireFormat);
        if (wireFormat) {
            message.status = KernelWorkerStatusWireFormat3.fromJson(wireFormat.status);
        }
        if (wireFormat) {
            message.kernelVersionType = KernelVersionTypeWireFormat3.fromJson(wireFormat.kernelVersionType);
        }
        if (wireFormat) {
            message.sourceType = EditorTypeWireFormat3.fromJson(wireFormat.sourceType);
        }
        if (wireFormat) {
            message.language = LanguageWireFormat3.fromJson(wireFormat.language);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCreated) {
            message.dateCreated = new Date(wireFormat.dateCreated);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateEvaluated) {
            message.dateEvaluated = new Date(wireFormat.dateEvaluated);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCancelled) {
            message.dateCancelled = new Date(wireFormat.dateCancelled);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.commit) {
            message.commit = KernelBlobWireFormat3.fromJson(wireFormat.commit);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.resources) {
            message.resources = KernelSessionResourcesWireFormat3.fromJson(wireFormat.resources);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.runInfo) {
            message.runInfo = KernelSessionInfoWireFormat3.fromJson(wireFormat.runInfo);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
            message.dataSources = wireFormat.dataSources.map(function(i) {
                return DataSourceReferenceWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.acceleratorType = AcceleratorTypeWireFormat3.fromJson(wireFormat.acceleratorType);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.nextScheduledSessionDate) {
            message.nextScheduledSessionDate = new Date(wireFormat.nextScheduledSessionDate);
        }
        return message;
    }
};
var defaultKernelRunLog = {
    lineNumber: 0,
    elapsedSeconds: 0
};
export var KernelRunLogWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelRunLog, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.elapsedSeconds) != undefined) {
            message.elapsedSeconds = Number(wireFormat.elapsedSeconds);
        }
        if (wireFormat) {
            message.streamName = StreamNameWireFormat3.fromJson(wireFormat.streamName);
        }
        return message;
    }
};
var defaultKernelSession = {
    kernelId: 0,
    kernelRunId: 0,
    isInternetEnabled: false
};
export var KernelSessionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelSession, wireFormat);
        if (wireFormat) {
            message.type = KernelVersionTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat) {
            message.sourceType = EditorTypeWireFormat3.fromJson(wireFormat.sourceType);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCreated) {
            message.dateCreated = new Date(wireFormat.dateCreated);
        }
        if (wireFormat) {
            message.accelerator = AcceleratorTypeWireFormat3.fromJson(wireFormat.accelerator);
        }
        return message;
    }
};
var defaultKernelSessionInfo = {
    exitCode: 0,
    runTimeSeconds: 0,
    usedAllSpace: false,
    timeoutExceeded: false,
    outOfMemory: false,
    invalidPathErrors: false,
    succeeded: false,
    wasKilled: false
};
export var KernelSessionInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelSessionInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.outputSizeBytes) {
            message.outputSizeBytes = parseInt(wireFormat.outputSizeBytes);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.runTimeSeconds) != undefined) {
            message.runTimeSeconds = Number(wireFormat.runTimeSeconds);
        }
        return message;
    }
};
var defaultKernelSessionList = {
    totalCount: 0,
    sessions: []
};
export var KernelSessionListWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelSessionList, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.quotaLimits) {
            message.quotaLimits = KernelSessionQuotaLimitsWireFormat3.fromJson(wireFormat.quotaLimits);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.sessions) {
            message.sessions = wireFormat.sessions.map(function(i) {
                return KernelSessionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultKernelSessionOutputFile = {
    kernelSessionId: 0,
    kernelId: 0,
    contentLength: 0
};
export var KernelSessionOutputFileWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelSessionOutputFile, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.contentLength) {
            message.contentLength = parseInt(wireFormat.contentLength);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.contentLength) {
            wireFormat.contentLength = message.contentLength.toString();
        }
        return wireFormat;
    }
};
var defaultKernelSessionQuotaLimits = {
    gpuInteractive: 0,
    gpuBatch: 0,
    cpuInteractive: 0,
    cpuBatch: 0,
    tpuInteractive: 0,
    tpuBatch: 0
};
export var KernelSessionQuotaLimitsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelSessionQuotaLimits, wireFormat);
        return message;
    }
};
var defaultKernelSessionResources = {
    storageBytes: 0,
    memoryBytes: 0,
    cpuCores: 0,
    sessionTimeoutSeconds: 0,
    idleTimeoutSeconds: 0
};
export var KernelSessionResourcesWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelSessionResources, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.storageBytes) {
            message.storageBytes = parseInt(wireFormat.storageBytes);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.memoryBytes) {
            message.memoryBytes = parseInt(wireFormat.memoryBytes);
        }
        return message;
    }
};
var defaultKernelSessionScore = {
    score: 0,
    kernelVersionNumber: 0,
    kernelSessionUrl: ""
};
export var KernelSessionScoreWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelSessionScore, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.score) != undefined) {
            message.score = Number(wireFormat.score);
        }
        return message;
    }
};
var defaultKernelShelf = {
    kernels: [],
    totalKernels: 0
};
export var KernelShelfWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelShelf, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernels) {
            message.kernels = wireFormat.kernels.map(function(i) {
                return KernelListItemWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.moreKernelsRequest) {
            message.moreKernelsRequest = ListKernelIdsRequestWireFormat3.fromJson(wireFormat.moreKernelsRequest);
        }
        return message;
    }
};
var defaultKernelSubmission = {
    submissionId: 0,
    status: 0
};
export var KernelSubmissionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelSubmission, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.date) {
            message.date = new Date(wireFormat.date);
        }
        return message;
    }
};
var defaultKernelVersion = {
    id: 0,
    versionNumber: 0,
    linesTotal: 0,
    linesInserted: 0,
    linesDeleted: 0
};
export var KernelVersionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelVersion, wireFormat);
        if (wireFormat) {
            message.pinningType = KernelVersionPinningTypeWireFormat3.fromJson(wireFormat.pinningType);
        }
        if (wireFormat) {
            message.versionType = KernelVersionTypeWireFormat3.fromJson(wireFormat.versionType);
        }
        return message;
    }
};
var defaultKernelVersionAndRun = {
    isForkParent: false,
    viewerUrl: ""
};
export var KernelVersionAndRunWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelVersionAndRun, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.author) {
            message.author = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.author);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.version) {
            message.version = KernelVersionWireFormat3.fromJson(wireFormat.version);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.run) {
            message.run = KernelRunWireFormat3.fromJson(wireFormat.run);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.blob) {
            message.blob = KernelBlobWireFormat3.fromJson(wireFormat.blob);
        }
        return message;
    }
};
var defaultKernelVersionHistory = {
    id: 0,
    isForkParent: false,
    isNotebook: false,
    linesChangedFromPrevious: 0,
    linesDeletedFromPrevious: 0,
    linesInsertedFromPrevious: 0,
    outputFilesTotalSizeBytes: 0,
    url: "",
    versionNumber: 0,
    hasVersionNumber: false,
    isRedacted: false
};
export var KernelVersionHistoryWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelVersionHistory, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastRunTime) {
            message.lastRunTime = new Date(wireFormat.lastRunTime);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.outputFilesTotalSizeBytes) {
            message.outputFilesTotalSizeBytes = parseInt(wireFormat.outputFilesTotalSizeBytes);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.runInfo) {
            message.runInfo = KernelVersionRunInfoWireFormat3.fromJson(wireFormat.runInfo);
        }
        if (wireFormat) {
            message.status = KernelWorkerStatusWireFormat3.fromJson(wireFormat.status);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.versionAuthor) {
            message.versionAuthor = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.versionAuthor);
        }
        if (wireFormat) {
            message.versionType = KernelVersionTypeWireFormat3.fromJson(wireFormat.versionType);
        }
        return message;
    }
};
var defaultKernelVersionList = {
    items: []
};
export var KernelVersionListWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelVersionList, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.items) {
            message.items = wireFormat.items.map(function(i) {
                return KernelVersionAndRunWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultKernelVersionRunInfo = {
    exitCode: 0,
    isValidStatus: false,
    succeeded: false,
    timeoutExceeded: false
};
export var KernelVersionRunInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultKernelVersionRunInfo, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.runTimeSeconds) != undefined) {
            message.runTimeSeconds = Number(wireFormat.runTimeSeconds);
        }
        return message;
    }
};
var defaultLinkModel = {
    showZeroCountExplicitly: false
};
export var LinkModelWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLinkModel, wireFormat);
        return message;
    }
};
export var ListCompetitionKernelsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.listKernelsRequest) {
            wireFormat.listKernelsRequest = ListKernelsRequestWireFormat3.toJson(message.listKernelsRequest);
        }
        return wireFormat;
    }
};
export var ListDockerImagesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ListGithubRepositoriesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListGithubRepositoriesResponse = {
    repositories: []
};
export var ListGithubRepositoriesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListGithubRepositoriesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.repositories) {
            message.repositories = wireFormat.repositories.map(function(i) {
                return GithubRepositoryInfoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListGithubRepositoryBranchesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListGithubRepositoryBranchesResponse = {
    branches: []
};
export var ListGithubRepositoryBranchesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListGithubRepositoryBranchesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.branches) {
            message.branches = wireFormat.branches.map(function(i) {
                return GithubBranchInfoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListGithubRepositoryFilesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListGithubRepositoryFilesResponse = {
    files: []
};
export var ListGithubRepositoryFilesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListGithubRepositoryFilesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.files) {
            message.files = wireFormat.files.map(function(i) {
                return GithubFileInfoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultListKernelIdsRequest = {
    excludeResultsFilesOutputs: false,
    page: 0,
    pageSize: 0,
    wantOutputFiles: false,
    excludeKernelIds: [],
    modelInstanceIds: []
};
export var ListKernelIdsRequestWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListKernelIdsRequest, wireFormat);
        if (wireFormat) {
            message.group = KernelsListViewTypeWireFormat3.fromJson(wireFormat.group);
        }
        if (wireFormat) {
            message.sortBy = KernelsListSortTypeWireFormat3.fromJson(wireFormat.sortBy);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.group) {
            wireFormat.group = KernelsListViewTypeWireFormat3.toJson(message.group);
        }
        if (message === null || message === void 0 ? void 0 : message.sortBy) {
            wireFormat.sortBy = KernelsListSortTypeWireFormat3.toJson(message.sortBy);
        }
        return wireFormat;
    }
};
var defaultListKernelIdsResponse = {
    kernelIds: []
};
export var ListKernelIdsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListKernelIdsResponse, wireFormat);
        return message;
    }
};
export var ListKernelPinsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListKernelPinsResponse = {
    kernelPins: []
};
export var ListKernelPinsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListKernelPinsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.kernelPins) {
            message.kernelPins = wireFormat.kernelPins.map(function(i) {
                return KernelPinListItemWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListKernelRunLogsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListKernelRunLogsResponse = {
    logs: []
};
export var ListKernelRunLogsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListKernelRunLogsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.logs) {
            message.logs = wireFormat.logs.map(function(i) {
                return KernelRunLogWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListKernelSessionOutputFilesHierarchicalRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListKernelSessionOutputFilesHierarchicalResponse = {
    directories: [],
    files: []
};
export var ListKernelSessionOutputFilesHierarchicalResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListKernelSessionOutputFilesHierarchicalResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.directories) {
            message.directories = wireFormat.directories.map(function(i) {
                return KaggleSdkDatasetsDatabundlesDirectoryWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.files) {
            message.files = wireFormat.files.map(function(i) {
                return KaggleSdkDatasetsDatabundlesFileWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListKernelSessionOutputRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListKernelSessionOutputResponse = {
    items: []
};
export var ListKernelSessionOutputResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListKernelSessionOutputResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.items) {
            message.items = wireFormat.items.map(function(i) {
                return KernelSessionOutputFileWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListKernelSessionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ListKernelsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.kernelFilterCriteria) {
            wireFormat.kernelFilterCriteria = SearchKernelIdsRequestWireFormat3.toJson(message.kernelFilterCriteria);
        }
        if (message === null || message === void 0 ? void 0 : message.detailFilterCriteria) {
            wireFormat.detailFilterCriteria = GetKernelListDetailsRequestWireFormat3.toJson(message.detailFilterCriteria);
        }
        return wireFormat;
    }
};
export var ListKernelVersionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ListSnippetsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListSnippetsResponse = {
    snippets: []
};
export var ListSnippetsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListSnippetsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.snippets) {
            message.snippets = wireFormat.snippets.map(function(i) {
                return SnippetWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultModelSource = {
    currentUserUpvoted: false,
    modelId: 0,
    modelInstanceVariationName: "",
    modelInstanceVersionId: 0,
    modelInstanceVersionUrl: "",
    modelOwnerImageUrl: "",
    modelOwnerName: "",
    modelSubtitle: "",
    modelTitle: "",
    voteCount: 0
};
export var ModelSourceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultModelSource, wireFormat);
        if (wireFormat) {
            message.modelInstanceFramework = KaggleSdkModelsModelFrameworkWireFormat3.fromJson(wireFormat.modelInstanceFramework);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.modelTags) {
            message.modelTags = KaggleSdkTagsTagListWireFormat3.fromJson(wireFormat.modelTags);
        }
        return message;
    }
};
var defaultParentKernelVersionData = {
    kernelVersionId: 0
};
export var ParentKernelVersionDataWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultParentKernelVersionData, wireFormat);
        return message;
    }
};
export var RemoveKernelCategoryRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var RunEpisodeRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.episodeType) {
            wireFormat.episodeType = KaggleSdkCompetitionsEpisodeTypeWireFormat3.toJson(message.episodeType);
        }
        if (message === null || message === void 0 ? void 0 : message.agents) {
            wireFormat.agents = message.agents.map(function(i) {
                return AgentEntryWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.renderType) {
            wireFormat.renderType = KaggleSdkCompetitionsEnvironmentRenderTypeWireFormat3.toJson(message.renderType);
        }
        return wireFormat;
    }
};
var defaultRunEpisodeResponse = {};
export var RunEpisodeResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRunEpisodeResponse, wireFormat);
        return message;
    }
};
var defaultScheduledKernelSession = {
    id: 0,
    kernelId: 0,
    iterations: 0,
    iteration: 0
};
export var ScheduledKernelSessionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultScheduledKernelSession, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationDate) {
            message.creationDate = new Date(wireFormat.creationDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.startDate) {
            message.startDate = new Date(wireFormat.startDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastSessionDate) {
            message.lastSessionDate = new Date(wireFormat.lastSessionDate);
        }
        if (wireFormat) {
            message.frequency = ScheduleFrequencyTypeWireFormat3.fromJson(wireFormat.frequency);
        }
        if (wireFormat) {
            message.trigger = ScheduleTriggerTypeWireFormat3.fromJson(wireFormat.trigger);
        }
        return message;
    }
};
export var ScheduleKernelSessionRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.trigger) {
            wireFormat.trigger = ScheduleTriggerTypeWireFormat3.toJson(message.trigger);
        }
        if (message === null || message === void 0 ? void 0 : message.frequency) {
            wireFormat.frequency = ScheduleFrequencyTypeWireFormat3.toJson(message.frequency);
        }
        if (message === null || message === void 0 ? void 0 : message.startDate) {
            wireFormat.startDate = message.startDate.toISOString();
        }
        return wireFormat;
    }
};
export var SearchKernelIdsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.listRequest) {
            wireFormat.listRequest = ListKernelIdsRequestWireFormat3.toJson(message.listRequest);
        }
        return wireFormat;
    }
};
var defaultSearchKernelIdsResponse = {
    kernelIds: []
};
export var SearchKernelIdsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSearchKernelIdsResponse, wireFormat);
        return message;
    }
};
var defaultSnippet = {
    id: 0,
    authorUserId: 0
};
export var SnippetWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSnippet, wireFormat);
        return message;
    }
};
export var SnippetDataWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSnippetReference = {
    lineNumber: 0
};
export var SnippetReferenceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSnippetReference, wireFormat);
        return message;
    }
};
var defaultSourceIndexReference = {
    kernelId: 0,
    kernelRunId: 0,
    dataSources: [],
    totalVotes: 0,
    definitions: [],
    snippets: [],
    totalSnippetCount: 0
};
export var SourceIndexReferenceWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSourceIndexReference, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
            message.dataSources = wireFormat.dataSources.map(function(i) {
                return DataSourceWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateEvaluated) {
            message.dateEvaluated = new Date(wireFormat.dateEvaluated);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.definitions) {
            message.definitions = wireFormat.definitions.map(function(i) {
                return SnippetReferenceWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.snippets) {
            message.snippets = wireFormat.snippets.map(function(i) {
                return SnippetReferenceWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var SubmissionRequestedDetailsWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultTag = {};
export var TagWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTag, wireFormat);
        return message;
    }
};
var defaultUpdateDataSourceResult = {};
export var UpdateDataSourceResultWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateDataSourceResult, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.reference) {
            message.reference = DataSourceReferenceWireFormat3.fromJson(wireFormat.reference);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.mountedVersion) {
            message.mountedVersion = DataSourceVersionWireFormat3.fromJson(wireFormat.mountedVersion);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.newVersion) {
            message.newVersion = DataSourceVersionWireFormat3.fromJson(wireFormat.newVersion);
        }
        return message;
    }
};
export var UpdateDefaultSessionSettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.settings) {
            wireFormat.settings = DefaultSessionSettingsWireFormat3.toJson(message.settings);
        }
        return wireFormat;
    }
};
export var UpdateDockerImageVersionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateDockerPinningTypeRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.dockerImagePinningType) {
            wireFormat.dockerImagePinningType = DockerImagePinningTypeWireFormat3.toJson(message.dockerImagePinningType);
        }
        return wireFormat;
    }
};
export var UpdateKernelCollaboratorsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.collaborators) {
            wireFormat.collaborators = KaggleSdkUsersCollaboratorListWireFormat3.toJson(message.collaborators);
        }
        return wireFormat;
    }
};
var defaultUpdateKernelCollaboratorsResponse = {
    privateDataSources: []
};
export var UpdateKernelCollaboratorsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateKernelCollaboratorsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.privateDataSources) {
            message.privateDataSources = wireFormat.privateDataSources.map(function(i) {
                return DataSourceWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.collaborators) {
            message.collaborators = KaggleSdkUsersCollaboratorListWireFormat3.fromJson(wireFormat.collaborators);
        }
        return message;
    }
};
export var UpdateKernelDraftRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.settings) {
            wireFormat.settings = KernelBlobSettingsWireFormat3.toJson(message.settings);
        }
        if (message === null || message === void 0 ? void 0 : message.externalSourceData) {
            wireFormat.externalSourceData = ExternalSourceDataWireFormat3.toJson(message.externalSourceData);
        }
        return wireFormat;
    }
};
var defaultUpdateKernelDraftResponse = {
    sequence: 0,
    kernelVersionId: 0
};
export var UpdateKernelDraftResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateKernelDraftResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.computedParent) {
            message.computedParent = ParentKernelVersionDataWireFormat3.fromJson(wireFormat.computedParent);
        }
        return message;
    }
};
export var UpdateKernelOutputToDatasetRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateKernelPersistenceRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.persistence) {
            wireFormat.persistence = PersistenceModeWireFormat3.toJson(message.persistence);
        }
        return wireFormat;
    }
};
var defaultUpdateKernelPersistenceResponse = {};
export var UpdateKernelPersistenceResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateKernelPersistenceResponse, wireFormat);
        return message;
    }
};
export var UpdateKernelPrivacyRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultUpdateKernelPrivacyResponse = {
    canToggleVisibility: false
};
export var UpdateKernelPrivacyResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateKernelPrivacyResponse, wireFormat);
        return message;
    }
};
export var UpdateKernelRunDataSourcesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.dataSources) {
            wireFormat.dataSources = message.dataSources.map(function(i) {
                return DataSourceReferenceWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultUpdateKernelRunDataSourcesResponse = {
    results: [],
    anyChanges: false
};
export var UpdateKernelRunDataSourcesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateKernelRunDataSourcesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.results) {
            message.results = wireFormat.results.map(function(i) {
                return UpdateDataSourceResultWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var UpdateKernelSessionKeepaliveRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateKernelSessionRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.dataSources) {
            wireFormat.dataSources = message.dataSources.map(function(i) {
                return DataSourceReferenceWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultUpdateKernelSessionResponse = {
    restartRequired: false,
    dataSources: []
};
export var UpdateKernelSessionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateKernelSessionResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dataSources) {
            message.dataSources = wireFormat.dataSources.map(function(i) {
                return DataSourceReferenceWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var UpdateKernelTitleRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultUpdateKernelTitleResponse = {};
export var UpdateKernelTitleResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateKernelTitleResponse, wireFormat);
        return message;
    }
};
export var UpdateKernelVersionNameRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdatePinnedKernelSessionRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.pinningType) {
            wireFormat.pinningType = KernelVersionPinningTypeWireFormat3.toJson(message.pinningType);
        }
        return wireFormat;
    }
};
export var UpdateSnippetRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.data) {
            wireFormat.data = SnippetDataWireFormat3.toJson(message.data);
        }
        return wireFormat;
    }
};
export var UpdateUserKernelFirestoreAuthRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultUpdateUserKernelFirestoreAuthResponse = {};
export var UpdateUserKernelFirestoreAuthResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateUserKernelFirestoreAuthResponse, wireFormat);
        return message;
    }
};
export var UploadKernelSessionOutputRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var AcceleratorType;
(function(AcceleratorType) {
    AcceleratorType[// Note: the enum values below should correspond
    // exactly to the values in AcceleratorTypes table.
    // These values are also used to embed Kaggle metadata
    // into notebooks, which allow export/import of notebooks
    // to preserve the notebook's settings. Adding values is
    // fine, but they shouldn't be removed/renamed.
    "NONE"] = "none";
    AcceleratorType["NVIDIA_TESLA_K80"] = "nvidiaTeslaK80";
    AcceleratorType["GPU"] = "gpu";
    AcceleratorType["NVIDIA_TESLA_P100"] = "nvidiaTeslaP100";
    AcceleratorType["TPU_V2_8"] = "tpuV28";
    AcceleratorType["TPU_V3_8"] = "tpuV38";
    AcceleratorType["TPU_V2_32"] = "tpuV232";
    AcceleratorType["TPU_V2_128"] = "tpuV2128";
    AcceleratorType["TPU_V2_256"] = "tpuV2256";
    AcceleratorType["NVIDIA_TESLA_T4"] = "nvidiaTeslaT4";
    AcceleratorType["TPU1VM_V3_8"] = "tpu1vmV38";
    AcceleratorType["TPUVM_V3_8"] = "tpuvmV38";
})(AcceleratorType || (AcceleratorType = {}));
export var AcceleratorTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "ACCELERATOR_TYPE_NONE":
            default:
                return AcceleratorType.NONE;
            case "NVIDIA_TESLA_K80":
                return AcceleratorType.NVIDIA_TESLA_K80;
            case "GPU":
                return AcceleratorType.GPU;
            case "NVIDIA_TESLA_P100":
                return AcceleratorType.NVIDIA_TESLA_P100;
            case "TPU_V2_8":
                return AcceleratorType.TPU_V2_8;
            case "TPU_V3_8":
                return AcceleratorType.TPU_V3_8;
            case "TPU_V2_32":
                return AcceleratorType.TPU_V2_32;
            case "TPU_V2_128":
                return AcceleratorType.TPU_V2_128;
            case "TPU_V2_256":
                return AcceleratorType.TPU_V2_256;
            case "NVIDIA_TESLA_T4":
                return AcceleratorType.NVIDIA_TESLA_T4;
            case "TPU1VM_V3_8":
                return AcceleratorType.TPU1VM_V3_8;
            case "TPUVM_V3_8":
                return AcceleratorType.TPUVM_V3_8;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case AcceleratorType.NONE:
            case 0:
            default:
                return "ACCELERATOR_TYPE_NONE";
            case AcceleratorType.NVIDIA_TESLA_K80:
            case 1:
                return "NVIDIA_TESLA_K80";
            case AcceleratorType.GPU:
            case 2:
                return "GPU";
            case AcceleratorType.NVIDIA_TESLA_P100:
            case 2:
                return "NVIDIA_TESLA_P100";
            case AcceleratorType.TPU_V2_8:
            case 3:
                return "TPU_V2_8";
            case AcceleratorType.TPU_V3_8:
            case 4:
                return "TPU_V3_8";
            case AcceleratorType.TPU_V2_32:
            case 5:
                return "TPU_V2_32";
            case AcceleratorType.TPU_V2_128:
            case 6:
                return "TPU_V2_128";
            case AcceleratorType.TPU_V2_256:
            case 7:
                return "TPU_V2_256";
            case AcceleratorType.NVIDIA_TESLA_T4:
            case 8:
                return "NVIDIA_TESLA_T4";
            case AcceleratorType.TPU1VM_V3_8:
            case 9:
                return "TPU1VM_V3_8";
            case AcceleratorType.TPUVM_V3_8:
            case 9:
                return "TPUVM_V3_8";
        }
    }
};
export var AccessBehavior;
(function(AccessBehavior) {
    AccessBehavior["RETURN_SHELL_ENTRY"] = "returnShellEntry";
    AccessBehavior["RETURN_NOTHING"] = "returnNothing";
})(AccessBehavior || (AccessBehavior = {}));
export var AccessBehaviorWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case AccessBehavior.RETURN_SHELL_ENTRY:
            case 0:
            default:
                return "RETURN_SHELL_ENTRY";
            case AccessBehavior.RETURN_NOTHING:
            case 1:
                return "RETURN_NOTHING";
        }
    }
};
export var CreationSourceType;
(function(CreationSourceType) {
    CreationSourceType[// This enum is stored in the database, so new values should be added sequentially (don't edit field numbers).
    "UNSPECIFIED"] = "unspecified";
    CreationSourceType["COMPETITION_KERNEL_RERUN"] = "competitionKernelRerun";
    CreationSourceType["COMPETITION_METRIC_KERNEL"] = "competitionMetricKernel";
    CreationSourceType["COMPETITION_METRIC_VERSION"] = "competitionMetricVersion";
    CreationSourceType["SUBMISSION_EVALUATION"] = "submissionEvaluation";
})(CreationSourceType || (CreationSourceType = {}));
export var CreationSourceTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CreationSourceType.UNSPECIFIED:
            case 0:
            default:
                return "CREATION_SOURCE_TYPE_UNSPECIFIED";
            case CreationSourceType.COMPETITION_KERNEL_RERUN:
            case 1:
                return "COMPETITION_KERNEL_RERUN";
            case CreationSourceType.COMPETITION_METRIC_KERNEL:
            case 2:
                return "COMPETITION_METRIC_KERNEL";
            case CreationSourceType.COMPETITION_METRIC_VERSION:
            case 3:
                return "COMPETITION_METRIC_VERSION";
            case CreationSourceType.SUBMISSION_EVALUATION:
            case 4:
                return "SUBMISSION_EVALUATION";
        }
    }
};
export var DataSourceType;
(function(DataSourceType) {
    DataSourceType["COMPETITION"] = "competition";
    DataSourceType["DATASET_VERSION"] = "datasetVersion";
    DataSourceType["KERNEL_VERSION"] = "kernelVersion";
    DataSourceType["COMPETITION_EVALUATION"] = "competitionEvaluation";
    DataSourceType["MODEL_INSTANCE_VERSION"] = "modelInstanceVersion";
})(DataSourceType || (DataSourceType = {}));
export var DataSourceTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DATA_SOURCE_TYPE_COMPETITION":
            default:
                return DataSourceType.COMPETITION;
            case "DATA_SOURCE_TYPE_DATASET_VERSION":
                return DataSourceType.DATASET_VERSION;
            case "DATA_SOURCE_TYPE_KERNEL_VERSION":
                return DataSourceType.KERNEL_VERSION;
            case "DATA_SOURCE_TYPE_COMPETITION_EVALUATION":
                return DataSourceType.COMPETITION_EVALUATION;
            case "DATA_SOURCE_TYPE_MODEL_INSTANCE_VERSION":
                return DataSourceType.MODEL_INSTANCE_VERSION;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case DataSourceType.COMPETITION:
            case 0:
            default:
                return "DATA_SOURCE_TYPE_COMPETITION";
            case DataSourceType.DATASET_VERSION:
            case 1:
                return "DATA_SOURCE_TYPE_DATASET_VERSION";
            case DataSourceType.KERNEL_VERSION:
            case 2:
                return "DATA_SOURCE_TYPE_KERNEL_VERSION";
            case DataSourceType.COMPETITION_EVALUATION:
            case 3:
                return "DATA_SOURCE_TYPE_COMPETITION_EVALUATION";
            case DataSourceType.MODEL_INSTANCE_VERSION:
            case 4:
                return "DATA_SOURCE_TYPE_MODEL_INSTANCE_VERSION";
        }
    }
};
export var DockerImagePinningType;
(function(DockerImagePinningType) {
    DockerImagePinningType["UNSPECIFIED"] = "unspecified";
    DockerImagePinningType["ORIGINAL"] = "original";
    DockerImagePinningType["LATEST"] = "latest";
})(DockerImagePinningType || (DockerImagePinningType = {}));
export var DockerImagePinningTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DOCKER_IMAGE_PINNING_TYPE_UNSPECIFIED":
            default:
                return DockerImagePinningType.UNSPECIFIED;
            case "DOCKER_IMAGE_PINNING_TYPE_ORIGINAL":
                return DockerImagePinningType.ORIGINAL;
            case "DOCKER_IMAGE_PINNING_TYPE_LATEST":
                return DockerImagePinningType.LATEST;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case DockerImagePinningType.UNSPECIFIED:
            case 0:
            default:
                return "DOCKER_IMAGE_PINNING_TYPE_UNSPECIFIED";
            case DockerImagePinningType.ORIGINAL:
            case 1:
                return "DOCKER_IMAGE_PINNING_TYPE_ORIGINAL";
            case DockerImagePinningType.LATEST:
            case 2:
                return "DOCKER_IMAGE_PINNING_TYPE_LATEST";
        }
    }
};
export var DockerImageVersionDisabledReason;
(function(DockerImageVersionDisabledReason) {
    DockerImageVersionDisabledReason["UNSPECIFIED"] = "unspecified";
    DockerImageVersionDisabledReason["TPU_RESTRICTION"] = "tpuRestriction";
})(DockerImageVersionDisabledReason || (DockerImageVersionDisabledReason = {}));
export var DockerImageVersionDisabledReasonWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DOCKER_IMAGE_VERSION_DISABLED_REASON_UNSPECIFIED":
            default:
                return DockerImageVersionDisabledReason.UNSPECIFIED;
            case "TPU_RESTRICTION":
                return DockerImageVersionDisabledReason.TPU_RESTRICTION;
        }
    }
};
export var DockerImageVersionType;
(function(DockerImageVersionType) {
    DockerImageVersionType["LATEST"] = "latest";
    DockerImageVersionType["ORIGINAL"] = "original";
    DockerImageVersionType["COMPETITION"] = "competition";
})(DockerImageVersionType || (DockerImageVersionType = {}));
export var DockerImageVersionTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DOCKER_IMAGE_VERSION_TYPE_LATEST":
            default:
                return DockerImageVersionType.LATEST;
            case "DOCKER_IMAGE_VERSION_TYPE_ORIGINAL":
                return DockerImageVersionType.ORIGINAL;
            case "DOCKER_IMAGE_VERSION_TYPE_COMPETITION":
                return DockerImageVersionType.COMPETITION;
        }
    }
};
export var EditorType;
(function(EditorType) {
    EditorType["UNSPECIFIED"] = "unspecified";
    EditorType["SCRIPT"] = "script";
    EditorType["NOTEBOOK"] = "notebook";
})(EditorType || (EditorType = {}));
export var EditorTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "EDITOR_TYPE_UNSPECIFIED":
            default:
                return EditorType.UNSPECIFIED;
            case "EDITOR_TYPE_SCRIPT":
                return EditorType.SCRIPT;
            case "EDITOR_TYPE_NOTEBOOK":
                return EditorType.NOTEBOOK;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case EditorType.UNSPECIFIED:
            case 0:
            default:
                return "EDITOR_TYPE_UNSPECIFIED";
            case EditorType.SCRIPT:
            case 1:
                return "EDITOR_TYPE_SCRIPT";
            case EditorType.NOTEBOOK:
            case 2:
                return "EDITOR_TYPE_NOTEBOOK";
        }
    }
};
export var KernelAccessType;
(function(KernelAccessType) {
    KernelAccessType["ADMINISTRATIVE"] = "administrative";
    KernelAccessType["READ"] = "read";
    KernelAccessType["WRITE"] = "write";
    KernelAccessType["COMMENT"] = "comment";
})(KernelAccessType || (KernelAccessType = {}));
export var KernelsListSortType;
(function(KernelsListSortType) {
    KernelsListSortType["HOTNESS"] = "hotness";
    KernelsListSortType["COMMENT_COUNT"] = "commentCount";
    KernelsListSortType["DATE_CREATED"] = "dateCreated";
    KernelsListSortType["DATE_RUN"] = "dateRun";
    KernelsListSortType["RELEVANCE"] = "relevance";
    KernelsListSortType["SCORE_ASCENDING"] = "scoreAscending";
    KernelsListSortType["SCORE_DESCENDING"] = "scoreDescending";
    KernelsListSortType["VIEW_COUNT"] = "viewCount";
    KernelsListSortType["VOTE_COUNT"] = "voteCount";
})(KernelsListSortType || (KernelsListSortType = {}));
export var KernelsListSortTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "HOTNESS":
            default:
                return KernelsListSortType.HOTNESS;
            case "COMMENT_COUNT":
                return KernelsListSortType.COMMENT_COUNT;
            case "DATE_CREATED":
                return KernelsListSortType.DATE_CREATED;
            case "DATE_RUN":
                return KernelsListSortType.DATE_RUN;
            case "RELEVANCE":
                return KernelsListSortType.RELEVANCE;
            case "SCORE_ASCENDING":
                return KernelsListSortType.SCORE_ASCENDING;
            case "SCORE_DESCENDING":
                return KernelsListSortType.SCORE_DESCENDING;
            case "VIEW_COUNT":
                return KernelsListSortType.VIEW_COUNT;
            case "VOTE_COUNT":
                return KernelsListSortType.VOTE_COUNT;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case KernelsListSortType.HOTNESS:
            case 0:
            default:
                return "HOTNESS";
            case KernelsListSortType.COMMENT_COUNT:
            case 1:
                return "COMMENT_COUNT";
            case KernelsListSortType.DATE_CREATED:
            case 2:
                return "DATE_CREATED";
            case KernelsListSortType.DATE_RUN:
            case 3:
                return "DATE_RUN";
            case KernelsListSortType.RELEVANCE:
            case 4:
                return "RELEVANCE";
            case KernelsListSortType.SCORE_ASCENDING:
            case 5:
                return "SCORE_ASCENDING";
            case KernelsListSortType.SCORE_DESCENDING:
            case 6:
                return "SCORE_DESCENDING";
            case KernelsListSortType.VIEW_COUNT:
            case 7:
                return "VIEW_COUNT";
            case KernelsListSortType.VOTE_COUNT:
            case 8:
                return "VOTE_COUNT";
        }
    }
};
export var KernelsListViewType;
(function(KernelsListViewType) {
    KernelsListViewType["UNSPECIFIED"] = "unspecified";
    KernelsListViewType["PROFILE"] = "profile";
    KernelsListViewType["UPVOTED"] = "upvoted";
    KernelsListViewType["EVERYONE"] = "everyone";
    KernelsListViewType["COLLABORATION"] = "collaboration";
    KernelsListViewType["FORK"] = "fork";
    KernelsListViewType["BOOKMARKED"] = "bookmarked";
    KernelsListViewType["RECENTLY_VIEWED"] = "recentlyViewed";
})(KernelsListViewType || (KernelsListViewType = {}));
export var KernelsListViewTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "KERNELS_LIST_VIEW_TYPE_UNSPECIFIED":
            default:
                return KernelsListViewType.UNSPECIFIED;
            case "PROFILE":
                return KernelsListViewType.PROFILE;
            case "UPVOTED":
                return KernelsListViewType.UPVOTED;
            case "EVERYONE":
                return KernelsListViewType.EVERYONE;
            case "COLLABORATION":
                return KernelsListViewType.COLLABORATION;
            case "FORK":
                return KernelsListViewType.FORK;
            case "BOOKMARKED":
                return KernelsListViewType.BOOKMARKED;
            case "RECENTLY_VIEWED":
                return KernelsListViewType.RECENTLY_VIEWED;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case KernelsListViewType.UNSPECIFIED:
            case 0:
            default:
                return "KERNELS_LIST_VIEW_TYPE_UNSPECIFIED";
            case KernelsListViewType.PROFILE:
            case 1:
                return "PROFILE";
            case KernelsListViewType.UPVOTED:
            case 2:
                return "UPVOTED";
            case KernelsListViewType.EVERYONE:
            case 3:
                return "EVERYONE";
            case KernelsListViewType.COLLABORATION:
            case 4:
                return "COLLABORATION";
            case KernelsListViewType.FORK:
            case 5:
                return "FORK";
            case KernelsListViewType.BOOKMARKED:
            case 6:
                return "BOOKMARKED";
            case KernelsListViewType.RECENTLY_VIEWED:
            case 7:
                return "RECENTLY_VIEWED";
        }
    }
};
export var KernelVersionPinningType;
(function(KernelVersionPinningType) {
    KernelVersionPinningType["UNPINNED"] = "unpinned";
    KernelVersionPinningType["PINNED"] = "pinned";
})(KernelVersionPinningType || (KernelVersionPinningType = {}));
export var KernelVersionPinningTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "UNPINNED":
            default:
                return KernelVersionPinningType.UNPINNED;
            case "PINNED":
                return KernelVersionPinningType.PINNED;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case KernelVersionPinningType.UNPINNED:
            case 0:
            default:
                return "UNPINNED";
            case KernelVersionPinningType.PINNED:
            case 1:
                return "PINNED";
        }
    }
};
export var KernelVersionType;
(function(KernelVersionType) {
    KernelVersionType["UNSPECIFIED"] = "unspecified";
    KernelVersionType["BATCH"] = "batch";
    KernelVersionType["INTERACTIVE"] = "interactive";
    KernelVersionType["QUICK"] = "quick";
})(KernelVersionType || (KernelVersionType = {}));
export var KernelVersionTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "KERNEL_VERSION_TYPE_UNSPECIFIED":
            default:
                return KernelVersionType.UNSPECIFIED;
            case "BATCH":
                return KernelVersionType.BATCH;
            case "INTERACTIVE":
                return KernelVersionType.INTERACTIVE;
            case "QUICK":
                return KernelVersionType.QUICK;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case KernelVersionType.UNSPECIFIED:
            case 0:
            default:
                return "KERNEL_VERSION_TYPE_UNSPECIFIED";
            case KernelVersionType.BATCH:
            case 1:
                return "BATCH";
            case KernelVersionType.INTERACTIVE:
            case 2:
                return "INTERACTIVE";
            case KernelVersionType.QUICK:
            case 3:
                return "QUICK";
        }
    }
};
export var KernelWorkerStatus;
(function(KernelWorkerStatus) {
    KernelWorkerStatus["QUEUED"] = "queued";
    KernelWorkerStatus["RUNNING"] = "running";
    KernelWorkerStatus["COMPLETE"] = "complete";
    KernelWorkerStatus["ERROR"] = "error";
    KernelWorkerStatus["CANCEL_REQUESTED"] = "cancelRequested";
    KernelWorkerStatus["CANCEL_ACKNOWLEDGED"] = "cancelAcknowledged";
    KernelWorkerStatus["NEW_SCRIPT"] = "newScript";
})(KernelWorkerStatus || (KernelWorkerStatus = {}));
export var KernelWorkerStatusWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "QUEUED":
            default:
                return KernelWorkerStatus.QUEUED;
            case "RUNNING":
                return KernelWorkerStatus.RUNNING;
            case "COMPLETE":
                return KernelWorkerStatus.COMPLETE;
            case "ERROR":
                return KernelWorkerStatus.ERROR;
            case "CANCEL_REQUESTED":
                return KernelWorkerStatus.CANCEL_REQUESTED;
            case "CANCEL_ACKNOWLEDGED":
                return KernelWorkerStatus.CANCEL_ACKNOWLEDGED;
            case "NEW_SCRIPT":
                return KernelWorkerStatus.NEW_SCRIPT;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case KernelWorkerStatus.QUEUED:
            case 0:
            default:
                return "QUEUED";
            case KernelWorkerStatus.RUNNING:
            case 1:
                return "RUNNING";
            case KernelWorkerStatus.COMPLETE:
            case 2:
                return "COMPLETE";
            case KernelWorkerStatus.ERROR:
            case 3:
                return "ERROR";
            case KernelWorkerStatus.CANCEL_REQUESTED:
            case 4:
                return "CANCEL_REQUESTED";
            case KernelWorkerStatus.CANCEL_ACKNOWLEDGED:
            case 5:
                return "CANCEL_ACKNOWLEDGED";
            case KernelWorkerStatus.NEW_SCRIPT:
            case 6:
                return "NEW_SCRIPT";
        }
    }
};
export var Language;
(function(Language) {
    Language["UNSPECIFIED"] = "unspecified";
    Language["PYTHON"] = "python";
    Language["R"] = "r";
    Language["RMARKDOWN"] = "rmarkdown";
    Language["JULIA"] = "julia";
    Language["SQLITE"] = "sqlite";
})(Language || (Language = {}));
export var LanguageWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "LANGUAGE_UNSPECIFIED":
            default:
                return Language.UNSPECIFIED;
            case "LANGUAGE_PYTHON":
                return Language.PYTHON;
            case "LANGUAGE_R":
                return Language.R;
            case "LANGUAGE_RMARKDOWN":
                return Language.RMARKDOWN;
            case "LANGUAGE_JULIA":
                return Language.JULIA;
            case "LANGUAGE_SQLITE":
                return Language.SQLITE;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case Language.UNSPECIFIED:
            case 0:
            default:
                return "LANGUAGE_UNSPECIFIED";
            case Language.PYTHON:
            case 1:
                return "LANGUAGE_PYTHON";
            case Language.R:
            case 2:
                return "LANGUAGE_R";
            case Language.RMARKDOWN:
            case 3:
                return "LANGUAGE_RMARKDOWN";
            case Language.JULIA:
            case 4:
                return "LANGUAGE_JULIA";
            case Language.SQLITE:
            case 5:
                return "LANGUAGE_SQLITE";
        }
    }
};
export var LegacyDataSourceType;
(function(LegacyDataSourceType) {
    LegacyDataSourceType["DATASET"] = "dataset";
    LegacyDataSourceType["COMPETITION"] = "competition";
    LegacyDataSourceType["KERNEL"] = "kernel";
})(LegacyDataSourceType || (LegacyDataSourceType = {}));
export var PersistenceMode;
(function(PersistenceMode) {
    PersistenceMode["UNSPECIFIED"] = "unspecified";
    PersistenceMode["NONE"] = "none";
    PersistenceMode["FILES"] = "files";
    PersistenceMode["VARS"] = "vars";
    PersistenceMode["FILES_AND_VARS"] = "filesAndVars";
})(PersistenceMode || (PersistenceMode = {}));
export var PersistenceModeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "PERSISTENCE_MODE_UNSPECIFIED":
            default:
                return PersistenceMode.UNSPECIFIED;
            case "PERSISTENCE_MODE_NONE":
                return PersistenceMode.NONE;
            case "PERSISTENCE_MODE_FILES":
                return PersistenceMode.FILES;
            case "PERSISTENCE_MODE_VARS":
                return PersistenceMode.VARS;
            case "PERSISTENCE_MODE_FILES_AND_VARS":
                return PersistenceMode.FILES_AND_VARS;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case PersistenceMode.UNSPECIFIED:
            case 0:
            default:
                return "PERSISTENCE_MODE_UNSPECIFIED";
            case PersistenceMode.NONE:
            case 1:
                return "PERSISTENCE_MODE_NONE";
            case PersistenceMode.FILES:
            case 2:
                return "PERSISTENCE_MODE_FILES";
            case PersistenceMode.VARS:
            case 3:
                return "PERSISTENCE_MODE_VARS";
            case PersistenceMode.FILES_AND_VARS:
            case 4:
                return "PERSISTENCE_MODE_FILES_AND_VARS";
        }
    }
};
export var ScheduleFrequencyType;
(function(ScheduleFrequencyType) {
    ScheduleFrequencyType["SCHEDULE_FREQUENCY_UNSPECIFIED"] = "scheduleFrequencyUnspecified";
    ScheduleFrequencyType["DAILY"] = "daily";
    ScheduleFrequencyType["WEEKLY"] = "weekly";
    ScheduleFrequencyType["MONTHLY"] = "monthly";
})(ScheduleFrequencyType || (ScheduleFrequencyType = {}));
export var ScheduleFrequencyTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "SCHEDULE_FREQUENCY_UNSPECIFIED":
            default:
                return ScheduleFrequencyType.SCHEDULE_FREQUENCY_UNSPECIFIED;
            case "DAILY":
                return ScheduleFrequencyType.DAILY;
            case "WEEKLY":
                return ScheduleFrequencyType.WEEKLY;
            case "MONTHLY":
                return ScheduleFrequencyType.MONTHLY;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ScheduleFrequencyType.SCHEDULE_FREQUENCY_UNSPECIFIED:
            case 0:
            default:
                return "SCHEDULE_FREQUENCY_UNSPECIFIED";
            case ScheduleFrequencyType.DAILY:
            case 1:
                return "DAILY";
            case ScheduleFrequencyType.WEEKLY:
            case 2:
                return "WEEKLY";
            case ScheduleFrequencyType.MONTHLY:
            case 3:
                return "MONTHLY";
        }
    }
};
export var ScheduleTriggerType;
(function(ScheduleTriggerType) {
    ScheduleTriggerType["UNSPECIFIED"] = "unspecified";
    ScheduleTriggerType["SCHEDULED_TIME"] = "scheduledTime";
    ScheduleTriggerType["DATASOURCE_UPDATE"] = "datasourceUpdate";
})(ScheduleTriggerType || (ScheduleTriggerType = {}));
export var ScheduleTriggerTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "SCHEDULE_TRIGGER_TYPE_UNSPECIFIED":
            default:
                return ScheduleTriggerType.UNSPECIFIED;
            case "SCHEDULED_TIME":
                return ScheduleTriggerType.SCHEDULED_TIME;
            case "DATASOURCE_UPDATE":
                return ScheduleTriggerType.DATASOURCE_UPDATE;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ScheduleTriggerType.UNSPECIFIED:
            case 0:
            default:
                return "SCHEDULE_TRIGGER_TYPE_UNSPECIFIED";
            case ScheduleTriggerType.SCHEDULED_TIME:
            case 1:
                return "SCHEDULED_TIME";
            case ScheduleTriggerType.DATASOURCE_UPDATE:
            case 2:
                return "DATASOURCE_UPDATE";
        }
    }
};
export var StreamName;
(function(StreamName) {
    StreamName["STDOUT"] = "stdout";
    StreamName["STDERR"] = "stderr";
})(StreamName || (StreamName = {}));
export var StreamNameWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "STREAM_NAME_STDOUT":
            default:
                return StreamName.STDOUT;
            case "STREAM_NAME_STDERR":
                return StreamName.STDERR;
        }
    }
};
// These RPCs are implemented in Kaggle.Services.Legacy due to dependency
// issues:
export var kernelsClient = {
    kernelsService: {
        acceptKernelCompetitionRules: createClient(AcceptKernelCompetitionRulesRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/AcceptKernelCompetitionRules"),
        addKernelCategory: createClient(AddKernelCategoryRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/AddKernelCategory"),
        cancelKernelSession: createClient(CancelKernelSessionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/CancelKernelSession"),
        clearPinnedKernelSession: createClient(ClearPinnedKernelSessionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/ClearPinnedKernelSession"),
        commitAndRun: createClient(CommitAndRunRequestWireFormat3, CommitAndRunResponseWireFormat3, "kernels.KernelsService/CommitAndRun"),
        completeQuickSession: createClient(CompleteQuickSessionRequestWireFormat3, CompleteQuickSessionResponseWireFormat3, "kernels.KernelsService/CompleteQuickSession"),
        computeKernelDiff: createClient(ComputeKernelDiffRequestWireFormat3, ComputeKernelDiffResponseWireFormat3, "kernels.KernelsService/ComputeKernelDiff"),
        createKernelPin: createClient(CreateKernelPinRequestWireFormat3, CreateKernelPinResponseWireFormat3, "kernels.KernelsService/CreateKernelPin"),
        createKernelSession: createClient(CreateKernelSessionRequestWireFormat3, CreateKernelSessionResponseWireFormat3, "kernels.KernelsService/CreateKernelSession"),
        createKernelUpvote: createClient(CreateKernelUpvoteRequestWireFormat3, CreateKernelUpvoteResponseWireFormat3, "kernels.KernelsService/CreateKernelUpvote"),
        createSnippet: createClient(CreateSnippetRequestWireFormat3, CreateSnippetResponseWireFormat3, "kernels.KernelsService/CreateSnippet"),
        deleteKernel: createClient(DeleteKernelRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/DeleteKernel"),
        deleteKernelPin: createClient(DeleteKernelPinRequestWireFormat3, DeleteKernelPinResponseWireFormat3, "kernels.KernelsService/DeleteKernelPin"),
        deleteKernelUpvote: createClient(DeleteKernelUpvoteRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/DeleteKernelUpvote"),
        deleteScheduledKernelSession: createClient(DeleteScheduledKernelSessionRequestWireFormat3, DeleteScheduledKernelSessionResponseWireFormat3, "kernels.KernelsService/DeleteScheduledKernelSession"),
        deleteSnippet: createClient(DeleteSnippetRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/DeleteSnippet"),
        fetchExternalKernelContent: createRawStringClient(FetchExternalKernelContentRequestWireFormat3, "kernels.KernelsService/FetchExternalKernelContent"),
        fetchGitHubContent: createClient(FetchGitHubContentRequestWireFormat3, FetchGitHubContentResponseWireFormat3, "kernels.KernelsService/FetchGitHubContent"),
        getAcceleratorQuotaStatistics: createClient(GetAcceleratorQuotaStatisticsRequestWireFormat3, GetAcceleratorQuotaStatisticsResponseWireFormat3, "kernels.KernelsService/GetAcceleratorQuotaStatistics"),
        getCompetitionsPaneInfo: createClient(GetCompetitionsPaneInfoRequestWireFormat3, GetCompetitionsPaneInfoResponseWireFormat3, "kernels.KernelsService/GetCompetitionsPaneInfo"),
        getDefaultSessionSettings: createClient(GetDefaultSessionSettingsRequestWireFormat3, DefaultSessionSettingsWireFormat3, "kernels.KernelsService/GetDefaultSessionSettings"),
        getDeletedKernel: createClient(GetDeletedKernelRequestWireFormat3, GetDeletedKernelResponseWireFormat3, "kernels.KernelsService/GetDeletedKernel"),
        getFirebaseAuthToken: createClient(GetFirebaseAuthTokenRequestWireFormat3, GetFirebaseAuthTokenResponseWireFormat3, "kernels.KernelsService/GetFirebaseAuthToken"),
        getFirebaseConfig: createClient(GetFirebaseConfigRequestWireFormat3, GetFirebaseConfigResponseWireFormat3, "kernels.KernelsService/GetFirebaseConfig"),
        getKernel: createClient(GetKernelRequestWireFormat3, KernelWireFormat3, "kernels.KernelsService/GetKernel"),
        getKernelCategoryIds: createClient(GetKernelCategoryIdsRequestWireFormat3, KernelCategoryIdListWireFormat3, "kernels.KernelsService/GetKernelCategoryIds"),
        getKernelCollaboratorList: createClient(GetKernelCollaboratorListRequestWireFormat3, GetKernelCollaboratorListResponseWireFormat3, "kernels.KernelsService/GetKernelCollaboratorList"),
        getKernelGitHubSettings: createClient(GetKernelGitHubSettingsRequestWireFormat3, GetKernelGitHubSettingsResponseWireFormat3, "kernels.KernelsService/GetKernelGitHubSettings"),
        getKernelIdByUrl: createClient(GetKernelIdByUrlRequestWireFormat3, GetKernelIdByUrlResponseWireFormat3, "kernels.KernelsService/GetKernelIdByUrl"),
        getKernelLandingPage: createClient(GetKernelLandingPageRequestWireFormat3, GetKernelLandingPageResponseWireFormat3, "kernels.KernelsService/GetKernelLandingPage"),
        getKernelListDetails: createClient(GetKernelListDetailsRequestWireFormat3, KernelListWireFormat3, "kernels.KernelsService/GetKernelListDetails"),
        getKernelRunSource: createRawStringClient(GetKernelRunSourceRequestWireFormat3, "kernels.KernelsService/GetKernelRunSource"),
        getKernelSessionDataSources: createClient(GetKernelSessionDataSourcesRequestWireFormat3, GetKernelSessionDataSourcesResponseWireFormat3, "kernels.KernelsService/GetKernelSessionDataSources"),
        getKernelSessionLog: createRawStringClient(GetKernelSessionLogRequestWireFormat3, "kernels.KernelsService/GetKernelSessionLog"),
        getKernelSessionModelSources: createClient(GetKernelSessionModelSourcesRequestWireFormat3, GetKernelSessionModelSourcesResponseWireFormat3, "kernels.KernelsService/GetKernelSessionModelSources"),
        getKernelStatus: createClient(GetKernelStatusRequestWireFormat3, GetKernelStatusResponseWireFormat3, "kernels.KernelsService/GetKernelStatus"),
        getKernelVersion: createClient(GetKernelVersionRequestWireFormat3, GetKernelVersionResponseWireFormat3, "kernels.KernelsService/GetKernelVersion"),
        getOrCreateKernelSession: createClient(GetOrCreateKernelSessionRequestWireFormat3, GetOrCreateKernelSessionResponseWireFormat3, "kernels.KernelsService/GetOrCreateKernelSession"),
        getScheduledKernelSession: createClient(GetScheduledKernelSessionRequestWireFormat3, GetScheduledKernelSessionResponseWireFormat3, "kernels.KernelsService/GetScheduledKernelSession"),
        getSourceIndexData: createClient(GetSourceIndexDataRequestWireFormat3, GetSourceIndexDataResponseWireFormat3, "kernels.KernelsService/GetSourceIndexData"),
        getUserKernelAchievements: createClient(GetUserKernelAchievementsRequestWireFormat3, GetUserKernelAchievementsResponseWireFormat3, "kernels.KernelsService/GetUserKernelAchievements"),
        hasAcceptedKernelCompetitionRules: createClient(HasAcceptedKernelCompetitionRulesRequestWireFormat3, HasAcceptedKernelCompetitionRulesResponseWireFormat3, "kernels.KernelsService/HasAcceptedKernelCompetitionRules"),
        indexAllSnippets: createClient(IndexAllSnippetsRequestWireFormat3, IndexAllSnippetsResponseWireFormat3, "kernels.KernelsService/IndexAllSnippets"),
        // TODO(b/246638612): merge this back into the regular ListKernels() to avoid
        // so many domain-specific kernel listing rpcs
        listCompetitionKernels: createClient(ListCompetitionKernelsRequestWireFormat3, CompetitionKernelsListsWireFormat3, "kernels.KernelsService/ListCompetitionKernels"),
        listDockerImages: createClient(ListDockerImagesRequestWireFormat3, DockerImageVersionDetailsListWireFormat3, "kernels.KernelsService/ListDockerImages"),
        listGithubRepositories: createClient(ListGithubRepositoriesRequestWireFormat3, ListGithubRepositoriesResponseWireFormat3, "kernels.KernelsService/ListGithubRepositories"),
        listGithubRepositoryBranches: createClient(ListGithubRepositoryBranchesRequestWireFormat3, ListGithubRepositoryBranchesResponseWireFormat3, "kernels.KernelsService/ListGithubRepositoryBranches"),
        listGithubRepositoryFiles: createClient(ListGithubRepositoryFilesRequestWireFormat3, ListGithubRepositoryFilesResponseWireFormat3, "kernels.KernelsService/ListGithubRepositoryFiles"),
        listKernelIds: createClient(ListKernelIdsRequestWireFormat3, ListKernelIdsResponseWireFormat3, "kernels.KernelsService/ListKernelIds"),
        listKernelPins: createClient(ListKernelPinsRequestWireFormat3, ListKernelPinsResponseWireFormat3, "kernels.KernelsService/ListKernelPins"),
        listKernelRunLogs: createClient(ListKernelRunLogsRequestWireFormat3, ListKernelRunLogsResponseWireFormat3, "kernels.KernelsService/ListKernelRunLogs"),
        listKernels: createClient(ListKernelsRequestWireFormat3, KernelListWireFormat3, "kernels.KernelsService/ListKernels"),
        listKernelSessionOutput: createClient(ListKernelSessionOutputRequestWireFormat3, ListKernelSessionOutputResponseWireFormat3, "kernels.KernelsService/ListKernelSessionOutput"),
        listKernelSessionOutputFilesHierarchical: createClient(ListKernelSessionOutputFilesHierarchicalRequestWireFormat3, ListKernelSessionOutputFilesHierarchicalResponseWireFormat3, "kernels.KernelsService/ListKernelSessionOutputFilesHierarchical"),
        listKernelSessions: createClient(ListKernelSessionsRequestWireFormat3, KernelSessionListWireFormat3, "kernels.KernelsService/ListKernelSessions"),
        listKernelVersions: createClient(ListKernelVersionsRequestWireFormat3, KernelVersionListWireFormat3, "kernels.KernelsService/ListKernelVersions"),
        listSnippets: createClient(ListSnippetsRequestWireFormat3, ListSnippetsResponseWireFormat3, "kernels.KernelsService/ListSnippets"),
        removeKernelCategory: createClient(RemoveKernelCategoryRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/RemoveKernelCategory"),
        runEpisode: createClient(RunEpisodeRequestWireFormat3, RunEpisodeResponseWireFormat3, "kernels.KernelsService/RunEpisode"),
        scheduleKernelSession: createClient(ScheduleKernelSessionRequestWireFormat3, ScheduledKernelSessionWireFormat3, "kernels.KernelsService/ScheduleKernelSession"),
        searchKernelIds: createClient(SearchKernelIdsRequestWireFormat3, SearchKernelIdsResponseWireFormat3, "kernels.KernelsService/SearchKernelIds"),
        updateDefaultSessionSettings: createClient(UpdateDefaultSessionSettingsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdateDefaultSessionSettings"),
        updateDockerImageVersion: createClient(UpdateDockerImageVersionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdateDockerImageVersion"),
        updateDockerPinningType: createClient(UpdateDockerPinningTypeRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdateDockerPinningType"),
        updateKernelCollaborators: createClient(UpdateKernelCollaboratorsRequestWireFormat3, UpdateKernelCollaboratorsResponseWireFormat3, "kernels.KernelsService/UpdateKernelCollaborators"),
        updateKernelDraft: createClient(UpdateKernelDraftRequestWireFormat3, UpdateKernelDraftResponseWireFormat3, "kernels.KernelsService/UpdateKernelDraft"),
        updateKernelOutputToDataset: createClient(UpdateKernelOutputToDatasetRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdateKernelOutputToDataset"),
        updateKernelPersistence: createClient(UpdateKernelPersistenceRequestWireFormat3, UpdateKernelPersistenceResponseWireFormat3, "kernels.KernelsService/UpdateKernelPersistence"),
        updateKernelPrivacy: createClient(UpdateKernelPrivacyRequestWireFormat3, UpdateKernelPrivacyResponseWireFormat3, "kernels.KernelsService/UpdateKernelPrivacy"),
        updateKernelRunDataSources: createClient(UpdateKernelRunDataSourcesRequestWireFormat3, UpdateKernelRunDataSourcesResponseWireFormat3, "kernels.KernelsService/UpdateKernelRunDataSources"),
        updateKernelSession: createClient(UpdateKernelSessionRequestWireFormat3, UpdateKernelSessionResponseWireFormat3, "kernels.KernelsService/UpdateKernelSession"),
        updateKernelSessionKeepalive: createClient(UpdateKernelSessionKeepaliveRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdateKernelSessionKeepalive"),
        updateKernelTitle: createClient(UpdateKernelTitleRequestWireFormat3, UpdateKernelTitleResponseWireFormat3, "kernels.KernelsService/UpdateKernelTitle"),
        updateKernelVersionName: createClient(UpdateKernelVersionNameRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdateKernelVersionName"),
        updatePinnedKernelSession: createClient(UpdatePinnedKernelSessionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdatePinnedKernelSession"),
        updateSnippet: createClient(UpdateSnippetRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UpdateSnippet"),
        updateUserKernelFirestoreAuth: createClient(UpdateUserKernelFirestoreAuthRequestWireFormat3, UpdateUserKernelFirestoreAuthResponseWireFormat3, "kernels.KernelsService/UpdateUserKernelFirestoreAuth"),
        uploadKernelSessionOutput: createClient(UploadKernelSessionOutputRequestWireFormat3, google.protobuf.EmptyWireFormat3, "kernels.KernelsService/UploadKernelSessionOutput")
    },
    legacyKernelsService: {
        exportKernelRunForCaip: createClient(ExportKernelRunForCaipRequestWireFormat3, ExportKernelRunForCaipResponseWireFormat3, "kernels.LegacyKernelsService/ExportKernelRunForCaip")
    }
};
